module.exports = __webpack_public_path__ + "img/neotag-banner2.ed763af7.png";